import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountClosePage} from 'features/deposit/pages/DepositAccountClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/deposits/$accountId/close/confirm',
)({
  component: DepositAccountClosePage,
});
